import { Button, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  button: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.4rem",
      height: "36px"
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.6rem",
      lineHeight: "5rem",
      padding: "0 16px"
    },
    fontWeight: 600
  }
}));

interface IOwnProps {
  className?: string;
  children: React.ReactNode;
  type?: "button" | "submit";
  onClick?: () => void;
  dataTestId?: string;
  disabled?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement>;
}

const CustomButton = ({ className, disabled, type, children, onClick, dataTestId, buttonRef }: IOwnProps) => {
  const classes = useStyles();

  const classNames = [classes.button];
  if (className) {
    classNames.push(className);
  }

  return (
    <Button
      ref={buttonRef}
      onClick={onClick}
      type={type}
      color="primary"
      disabled={disabled}
      className={classNames.join(" ")}
      data-qa-selector={dataTestId}
    >
      {children}
    </Button>
  );
};

export const DefaultButton = React.memo(CustomButton);
